import axios from "axios";

export const getAutocomplete = async (query, apiUrl) => {
  const params = '?query='+query
  const url = apiUrl +'autocomplete/'+ params
  const response = await axios.get(url)
  .then(res => {
    return res;
  })
  .catch((err) => {
    return false;
  }); 
    return response;
}

